import React, { useContext } from 'react';

import { ASSET_PATH } from '../../../../assetsPath';
import BannerCarousel from '../../../bizLanding/components/BannerCarousel/BannerCarousel';

import { bannerCarouselData } from '../config';
const mybizLogo = `${ASSET_PATH.IMAGES}landing/myBizLogo_light.png`;

const mainImagePng = `${ASSET_PATH.IMAGES}seo/expense/banner.png`;
import { isMobileContext } from '../../../UtilityComponents/Util';
import DisplayContext from '../../../UtilityComponents/displayContext';

const SeoCarousel = (props) =>{
	const displayName = useContext(DisplayContext).isMobile;
	const isMobile = isMobileContext(displayName);
	return (
		<BannerCarousel
			mybizLogo={mybizLogo}
			mainImages={{ mainImagePng }}
			bannerCarouselData={bannerCarouselData}
			isMobile={isMobile}
			isFullWidth
			height='575'
			imgOverlay
			bannerImgWidth='50%'
			{...props}
		/>
	);
};

export default SeoCarousel;
